export enum LocalStorageKeys {
    appLang = 'app-lang',
    CURRENT = 'CURRENT',
}
